import { render, staticRenderFns } from "./productoCard.vue?vue&type=template&id=5909bacc&scoped=true"
import script from "./productoCard.vue?vue&type=script&lang=js"
export * from "./productoCard.vue?vue&type=script&lang=js"
import style0 from "./productoCard.vue?vue&type=style&index=0&id=5909bacc&prod&scoped=true&lang=css"
import style1 from "./productoCard.vue?vue&type=style&index=1&id=5909bacc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5909bacc",
  null
  
)

export default component.exports